// "Buy more, save more" tiers (snippets/buy-more-save-more.liquid).
// Picking a tier sets the product form's quantity, so Add to cart adds that many; picking it again goes back to the minimum.
// The tier also follows the quantity box, so typing or using +/- selects the tier with that quantity, if there is one.
if (!customElements.get('buy-more-save-more')) {
  customElements.define(
    'buy-more-save-more',
    class BuyMoreSaveMore extends HTMLElement {
      connectedCallback() {
        this.input = document.getElementById(this.dataset.quantityInput);
        this.tiers = Array.from(this.querySelectorAll('.bmsm__tier'));
        this.tiers.forEach((tier) => tier.addEventListener('click', () => this.onTierClick(tier)));
        if (!this.input) return;
        this.onQuantityChange = () => this.sync();
        this.input.addEventListener('change', this.onQuantityChange);
        this.input.addEventListener('input', this.onQuantityChange);
        // product-info.js resets the box to the minimum after an add to cart without a change event, then publishes this.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onQuantityChange);
        }
        this.sync();
      }

      disconnectedCallback() {
        if (!this.input) return;
        this.input.removeEventListener('change', this.onQuantityChange);
        this.input.removeEventListener('input', this.onQuantityChange);
        if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
      }

      onTierClick(tier) {
        if (!this.input) return;
        const selected = tier.getAttribute('aria-checked') === 'true';
        this.input.value = selected ? this.input.min || 1 : tier.dataset.quantity;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      sync() {
        const quantity = parseInt(this.input.value, 10);
        this.tiers.forEach((tier) => {
          const selected = parseInt(tier.dataset.quantity, 10) === quantity;
          tier.setAttribute('aria-checked', selected ? 'true' : 'false');
          tier.classList.toggle('bmsm__tier--selected', selected);
        });
      }
    }
  );
}
